(function ($, _, engines, dataSets) {
    $.fn.chTokenField = function (typeName, allowNewTokens) {
        allowNewTokens = allowNewTokens || false;

        var elm = this;
        var val = this.val();
        var engine = engines.get(typeName);

        function initializeEngine(e) {
            engine.initialize();
            $(e.currentTarget).off('focus', initializeEngine);
        }
        
        if (val) {
            elm.attr('readonly', 'readonly').addClass('tokenfield-loading');

            var promise = null;
            var values = val.split(';');

            if (engine.prefetch) {
                promise = engine.initialize().done(function () {
                    init_inner(elm, typeName, addMissingValues(engine.get(values), values));
                });
            } else if (engine.remote) {
                engine.initialize();

                // load values
                promise = $.ajax({
                    method: 'GET',
                    url: engine.remote.url.replace('{s}', '') + '&ids=' + values.join('&ids=')
                });
                promise.done(function (data) {
                    init_inner(elm, typeName, addMissingValues(engine.remote.transform(data), values));
                });
            } else {
                throw 'engine requires prefetch or remote';
            }

            promise.always(function () {
                elm.removeAttr('readonly').removeClass('tokenfield-loading');
            });
        } else {
            init_inner(elm, typeName, []);

            var input = getInput(elm).on('focus', initializeEngine);
        }

        function addMissingValues(tokens, values) {
            _.each(
                _.difference(values,
                    _.map(tokens, function (o) { return '' + o.value; })),
                function (value) {
                    tokens.push({ label: 'id:' + value, value: value });
                });

            return tokens;
        }

        function init_inner(elm, type, tokens) {
            var config = {
                tokens: tokens,
                delimiter: ';',
                beautify: false,
                allowPasting: false,
                createTokensOnBlur: true,
                maxTokenWidth: 150,
                typeahead: [
                    {
                        highlight: true,
                        minLength: 1
                    },
                    dataSets.get(type)
                ]
            };

            // HACK can't be readonly when created
            elm.removeAttr('readonly');

            tokenfield(elm, config);

            elm.on('tokenfield:createtoken', function (e) {
                function invalid() {
                    setTimeout(function () {
                        getInput(elm).typeahead('val', '');
                    });
                    return false;
                }
                // validate 
                if (!allowNewTokens && e.attrs.label === e.attrs.value) {
                    return invalid();
                }
                // duplicates
                var tokens = $(this).tokenfield('getTokens');
                for (var i = 0; i < tokens.length; i++) {
                    var t = tokens[i];
                    if (t.value === e.attrs.value || t.label === e.attrs.value) {
                        return invalid();
                    }
                }
            });

            // disable editing tokens
            elm.on('tokenfield:edittoken', function (e) {
                return false;
            });

            // HACK tt-hint width is not adjusted and covers other fields
            elm.on('tokenfield:createdtoken tokenfield:removetoken', function (e) {
                var tt = $(e.currentTarget).siblings('.twitter-typeahead');
                setTimeout(function () {
                    $('.tt-hint', tt).width($('.tt-input', tt).width());
                });
            });
        }

        function getInput(elm) {
            return elm.parent().find('.token-input');
        }

        function tokenfield(elm, config) {
            elm.tokenfield(config);

            // HACK fix bug where tokenfield looses focus
            getInput(elm)
                .on('keydown keyup', function (e) {
                    switch (e.keyCode) {
                        case 8: // backspace
                        case 37: // left arrow
                        case 39: // right arrow
                            elm.tokenfield('focus');
                    }
                });
        }

        return this;
    }
}($, _, chTypeAhead.engines, chTypeAhead.dataSets));
